import { Meteor } from 'meteor/meteor';
import '@fontsource/fraunces/latin-600.css';
import '@fontsource/fraunces/latin-700.css';
import '@fontsource/space-grotesk/latin-400.css';
import '@fontsource/space-grotesk/latin-500.css';
import '@fontsource/space-grotesk/latin-600.css';
import '@fontsource/space-grotesk/latin-700.css';
import { auto as followSystemColorScheme } from 'darkreader';
import App from '../imports/ui/App.svelte';
import { mount, unmount } from 'svelte';

let app; // will hold the mounted instance

Meteor.startup(() => {
  const target = document.getElementById('app');

  // Match the OS/browser color scheme; no manual toggle to keep in sync.
  followSystemColorScheme({ brightness: 100, contrast: 90, sepia: 10 });

  // (Re)mount
  app = mount(App, { target });

  // Clean up on HMR so we don't double-mount
  if (import.meta.webpackHot) {
    import.meta.webpackHot.accept();
    import.meta.webpackHot.dispose(() => {
      if (app) {
        // pass the instance you got from mount()
        unmount(app, { outro: false }); // set outro:true if you want transitions
        app = null;
      }
      // optional: clear target to be extra safe
      target.innerHTML = '';
    });
  }
});
